<mat-form-field class="fd-label__container" color="accent">
    <input matInput 
          autocomplete="off" class="fd-label__text"
          [attr.disabled]="true"
          readonly
          [placeholder]="label"
          [value]="text"
          tabindex="-1">
</mat-form-field>